import React, { useEffect, useState } from "react";
import AdminNav from "../../navigation/AdminNav";
import { Grid, CircularProgress, Button } from '@material-ui/core'
import { useSelector, useDispatch } from 'react-redux';
import { getLecturerProjects, deleteLecturerProject, updateLecturerProject } from '../../actions/lecturerprojects';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import ClearIcon from '@material-ui/icons/Clear';

/**
 * This page presents the admin with a form to fill out to allow them to edit existing projects that were submitted by the lecturers.
 * When the project is submitted it will automatically show up on the screen which lets them know it submitted properly and be sent to the 
 * lecturer projects collection in the database.
 * @returns the project edit form along with a list of the projects that was created by all the different lecturers.
 */

function AdminManageLecturers() {

    const [lecturerProjects, setlecturerProject] = useState({
        title: '', description: ''
    });
    const [id, setID] = useState(null);

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getLecturerProjects());
    }, [dispatch, lecturerProjects]);

    const submitHandler = (e) => {
        e.preventDefault();

        if(id) {
            dispatch(updateLecturerProject(id, lecturerProjects));
            alert("Project Edited")
        }

        clearFields();
    }

    const handleProjectEdit = (project) => {
        const newProject = Object.assign({}, lecturerProjects)

        newProject.title = project.title;
        newProject.description = project.description;

        setID(project._id)
        setlecturerProject(newProject);
    }

    const clearFields = () => {
        setID(null);
        setlecturerProject({title: '', description: ''});
    }

    let projects = []
    const response = useSelector((state) => state.lecturerprojects.data);
    if (response){
        projects = Array.from(response);
    }

    return(
        <div>
            <AdminNav />
            <form id={id} onSubmit={submitHandler}>
                <h1>Manage Lecturer Project Database</h1>
                <p>Below are all of the lecturer recommended projects</p>
                <label>
                    Project Name: 
                    <input type="text" name="title" label="Name" value={lecturerProjects ? lecturerProjects.title : ''} onChange={(e) => setlecturerProject({...lecturerProjects, title: e.target.value})}></input>
                </label>
                <label>
                    Project Description: 
                    <input type="text" name="description" label="Description" value={lecturerProjects ? lecturerProjects.description : ''} onChange={(e) => setlecturerProject({...lecturerProjects, description: e.target.value})}></input>
                </label>
                <input className="submitButton" type="submit" name="submit" onClick={() => {}}></input>
                <Button onClick={clearFields}>
                    <ClearIcon/>
                    Clear
                </Button>
            </form>
            {!projects.length ? <CircularProgress /> : (
                <Grid>
                    {projects.map((project) => (
                        <Grid className="paper" key={project._id} item>
                            <p>{project.title}</p>
                            <p>{project.description}</p>
                            <Button onClick={() => handleProjectEdit(project)}>
                                <EditIcon/>
                                Edit
                            </Button>
                            <Button onClick={() => dispatch(deleteLecturerProject(project._id))}>
                                <DeleteIcon/>
                                Delete
                            </Button>
                        </Grid>
                    ))}
                </Grid>
            )}
        </div>
    )
}

export default AdminManageLecturers